import { FC, PropsWithChildren, SyntheticEvent } from 'react';
import cls from 'classnames';
import LeftIcon from 'icon/chevron_left.svg';
import RightIcon from 'icon/chevron_right.svg';
import { useAtomValue } from 'jotai/index';
import { $UserAgent } from '@lemon8/web-app-shared/atom';

import './style.scss';

type TStepScrollUI = PropsWithChildren<{
  className?: string;
  left: boolean;
  right: boolean;
  onClickLeft: (event: SyntheticEvent) => void;
  onClickRight: (event: SyntheticEvent) => void;
}>;

export const StepScrollUI: FC<TStepScrollUI> = (props) => {
  const { children, className, left, right, onClickRight, onClickLeft } = props;
  const { isMobile } = useAtomValue($UserAgent);

  const isPC = !isMobile;

  return (
    <div className={cls('step-scroll-ui', className)}>
      {children}
      {isPC && (
        <div className="step-scroll-ui-action">
          <div className={cls({ show: left })} onClick={onClickLeft}>
            <LeftIcon />
          </div>
          <div className={cls({ show: right })} onClick={onClickRight}>
            <RightIcon />
          </div>
        </div>
      )}
    </div>
  );
};
